import { Button } from "@do/ui/components/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@do/ui/components/tooltip";
import { cn } from "@do/ui/lib/utils";
import { Undo2Icon } from "lucide-react";
import { useTranslations } from "next-intl";
import { useChat } from "../../../../providers/chat-provider";

interface MessageActionBackButtonProps {
  id: string;
}

export const MessageActionBackButton = ({ id }: MessageActionBackButtonProps) => {
  const t = useTranslations("do-chat-v2");
  const { handleBackToPreviousStep, disabled, selectedLocale, defaultLocale } = useChat();

  return (
    <Tooltip group>
      <TooltipTrigger asChild>
        <Button
          id={`message-${id}-back-button`}
          disabled={disabled}
          onClick={handleBackToPreviousStep}
          size="icon"
          className={cn(
            "size-fit",
            "gap-(--message-actions-sources-gap)",
            "rounded-(--message-actions-border-radius)",
            "p-(--message-actions-padding)",
            "bg-(--message-actions-background)/(--message-actions-background-opacity)",
            "hover:bg-(--message-actions-hover-background)/(--message-actions-hover-background-opacity)",
            "text-(--message-actions-foreground)/(--message-actions-foreground-opacity)",
            "hover:text-(--message-actions-hover-foreground)/(--message-actions-hover-foreground-opacity)"
          )}
          aria-label={t("chat.messages.accessibility.message-back-aria-label")}
        >
          <Undo2Icon
            id={`message-${id}-back-button-icon`}
            aria-hidden="true"
            className="size-(--message-actions-icon-size)"
          />
          <span className="leading-none pt-px text-(length:--message-actions-sources-text-font-size)">
            {selectedLocale?.backButtonLabel ||
              defaultLocale?.backButtonLabel ||
              t("chat.messages.actions.back")}
          </span>
        </Button>
      </TooltipTrigger>

      <TooltipContent
        id={`message-${id}-back-button-tooltip`}
        side="bottom"
        arrowClassName={cn(
          "bg-(--message-actions-tooltip-background)/(--message-actions-tooltip-background-opacity)",
          "fill-(--message-actions-tooltip-background)/(--message-actions-tooltip-background-opacity)"
        )}
        className={cn(
          "bg-(--message-actions-tooltip-background)/(--message-actions-tooltip-background-opacity)",
          "text-(--message-actions-tooltip-foreground)/(--message-actions-tooltip-foreground-opacity)"
        )}
      >
        {t("chat.messages.actions.back-to-previous-step")}
      </TooltipContent>
    </Tooltip>
  );
};
